function  umeMoreFrontend() {
    if (document.querySelector('.ume-more-button')) {
        document.addEventListener('click', (ev) => {
            const matches = ev.target.matches ? ev.target.matches('.ume-more-button') : ev.target.msMatchesSelector('.ume-more-button');
            if (!matches) return;
            const button = ev.target;
            const isOpen = button.classList.contains('ume-more-button__open');
            const wrapper = ev.target.parentElement;
            const hidden = wrapper.querySelector('.ume-more-inner');
            const top = wrapper.querySelector('.ume-more-inner-top');
            if(!isOpen){
                hidden.classList.add('ume-more-inner__show');
                button.classList.add('ume-more-button__open');
                button.setAttribute('data-open-text', button.innerText);
                let closeText = button.getAttribute('data-close-text');
                if(closeText && closeText !== ''){
                    button.innerText = closeText;
                }else{
                    button.innerText = 'Weniger Lesen'
                }
            }
            if(isOpen){
                hidden.classList.remove('ume-more-inner__show');
                button.classList.remove('ume-more-button__open');
                let openText = button.getAttribute('data-open-text');
                button.innerText = openText;
            }

        });
    }
}
umeMoreFrontend();